import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { Modal, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { DeleteSize, GetSize } from "../../../redux/actions/productActions";
import DataTables from "../../common/DataTables";
import { toast } from 'react-toastify';
import { RESET_ERROR } from "../../../redux/constants/userConstants";
import DataTable from "react-data-table-component";
import SearchHeader from "../../common/header_components/searchHeader";
import AddSize from "./AddSize";
import sizedata from "./sizedata";
import moment from "moment";
import Reactotron from "reactotron-react-js"

const Sizes = () => {
    const dispatch = useDispatch()
    const [datas, setDatas] = useState([])
    const { getsizelist, sizedelsuccess, editedsize, newsize, error } = useSelector(state => state.product)
    const [open, setOpen] = useState(false);
    const [openedit, setOpenEdit] = useState(false);
    const [activeData, setActiveData] = useState(null)
    const [title, setTitle] = useState('')
    const [filterText, setFilterText] = useState('');

    Reactotron.log(getsizelist, "getsizelist")

    const customToast = "delS";
    const customCToast = "delSi";
    const customUToast = "delSiz";

    const Capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you wish to delete this size?")) {
            dispatch(DeleteSize(id))
        }
    }

    const handleEdit = (data) => {
        setTitle("Edit Size");
        setActiveData(data)
        setOpen(true)
    }

    const onOpenModal = () => {
        setTitle('Add Size')
        setActiveData(null)
        setOpen(true);
    };

    const onCloseModal = () => {
        setOpen(false);
    };
    const onOpenEditModal = () => {
        setOpenEdit(true);
    };

    const onCloseEditModal = () => {
        setOpenEdit(false);
    };
    useEffect(() => {
        dispatch(GetSize())
    }, [])

    useEffect(() => {
        if (getsizelist) {
            setDatas(getsizelist)
        }
    }, [getsizelist])

    useEffect(() => {
        if (sizedelsuccess) {
            toast.success("Size Deleted Successfully", { toastId: customToast });
            dispatch({
                type: RESET_ERROR
            })
        } else {
            toast.error(error)
        }
    }, [sizedelsuccess])

    useEffect(() => {
        if (newsize) {
            toast.success("Size Created Successfully", { toastId: customCToast });
            dispatch({
                type: RESET_ERROR
            })
            setActiveData(null);
            setOpen(false);
            setTitle('')
        }
    }, [newsize])

    useEffect(() => {
        if (editedsize) {
            toast.success("Size Updated Successfully", { toastId: customUToast });
            dispatch({
                type: RESET_ERROR
            })
            setActiveData(null);
            setOpen(false);
            setTitle('')
        }
    }, [editedsize])

    useEffect(() => {
        if (error) {
            toast.error(`${error.message}`);
            dispatch({
                type: RESET_ERROR
            })
        }
    }, [error])

    var columns = [
        {
            name: <b>{Capitalize("S.No")}</b>,
            header: <b>{Capitalize("S.No")}</b>,
            cell: (row, index) => index + 1
        },
        {
            name: <b>{Capitalize("Created At")}</b>,
            header: <b>{Capitalize("Created At")}</b>,
            cell: (row, index) => moment(row?.created_at).format('DD-MM-YYYY hh:mm A')
        },
        {
            name: <b>{Capitalize("Size Name")}</b>,
            header: <b>{Capitalize("Size Name")}</b>,
            selector: row => row?.name,
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>Actions</b>,
            id: "delete",
            accessor: (str) => "delete",
            cell: (row, index) => (
                <>
                    <span onClick={() => handleDelete(row._id)} >
                        <i
                            className="fa fa-trash"
                            style={{
                                width: 35,
                                fontSize: 20,
                                padding: 11,
                                color: "#e4566e",
                                cursor: "pointer"
                            }}
                        ></i>
                    </span>
                    <span onClick={() => handleEdit(row)}>
                        <i
                            className="fa fa-pencil"
                            style={{
                                width: 35,
                                fontSize: 20,
                                padding: 11,
                                color: "rgb(40, 167, 69)",
                                cursor: "pointer"
                            }}
                        ></i>
                    </span>
                </>
            )
        }
    ];

    const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setFilterText('');
            }
        };

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
                <SearchHeader onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
            </div>
        );
    }, [filterText]);

    useEffect(() => {
        let datas = getsizelist?.filter(cat => cat?.name?.toLowerCase().includes(filterText?.toLowerCase()))
        setDatas(datas)
    }, [filterText])

    return (
        <Fragment>
            <Breadcrumb title="Sizes" parent="Products" />
            {/* <!-- Container-fluid starts--> */}
            <Container fluid="true">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Sizes</h5>
                            </CardHeader>
                            <CardBody>
                                <div className="btn-popup pull-right">
                                    <Button
                                        type="button"
                                        color="secondary"
                                        onClick={onOpenModal}
                                        data-toggle="modal"
                                        data-original-title="test"
                                        data-target="#exampleModal"
                                    >
                                        Add Size
                                    </Button>
                                </div>
                                <div className="clearfix"></div>
                                <div id="basicScenario" className="product-physical">
                                    <DataTable
                                        pagination columns={columns}
                                        data={datas}
                                        fixedHeader
                                        subHeader
                                        subHeaderComponent={subHeaderComponentMemo}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <AddSize
                openModal={open}
                onCloseModal={() => {
                    setActiveData(null)
                    setOpen(false)
                }}
                data={activeData}
                setActiveData={setActiveData}
                title={title}
            />
        </Fragment>
    )
}

export default Sizes 